import { SVGProps } from 'react';

export const CopyIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      data-icon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_970_273)">
        <path
          d="M13.3333 0C14.8061 0 16 1.19391 16 2.66667V9.33333C16 10.8061 14.8061 12 13.3333 12H12V13.3333C12 14.8061 10.8061 16 9.33333 16H2.66667C1.19391 16 1.07391e-08 14.8061 0 13.3333V6.66667C0 5.19391 1.19391 4 2.66667 4H4V2.66667C4 1.19391 5.19391 1.07377e-08 6.66667 0H13.3333ZM2.77333 5.06667C1.83077 5.06667 1.06667 5.83077 1.06667 6.77333V13.2267C1.06667 14.1692 1.83077 14.9333 2.77333 14.9333H9.22667C10.1692 14.9333 10.9333 14.1692 10.9333 13.2267V6.77333C10.9333 5.83077 10.1692 5.06667 9.22667 5.06667H2.77333ZM9.33333 4C10.8061 4 12 5.19391 12 6.66667V10.9333H13.2267C14.1692 10.9333 14.9333 10.1692 14.9333 9.22667V2.77333C14.9333 1.83077 14.1692 1.06667 13.2267 1.06667H6.77333C5.83077 1.06667 5.06667 1.83077 5.06667 2.77333V4H9.33333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_970_273">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
